import React from 'react';

const CustomDropdownWithOther = ({
  options = [],
  onChange,
  placeholder = 'Select an option',
  otherLabel = 'Other',
  name,
  required = false,
  value = { id: '', name: '', policyNo:'' },
  otherTextBoxPlaceholder="",
  showError = false, // display error message
  errorMessage = ''
}) => {
  const isOtherSelected = value && value.id !== '' && (
    value.id === null ||
    !options.some(opt => String(opt.id) === String(value.id))
  );

  const handleSelectChange = (e) => {
    const val = e.target.value;

    if (val === 'other') {
      if (onChange) onChange({ id: null, name: '', policyNo: null });
    } else {
      const selectedItem = options.find((opt) => String(opt.id) === val);
      if (onChange) {
        onChange({
          id: selectedItem ? selectedItem.id : '',
          name: selectedItem ? selectedItem.name : ''
        });
      }
    }
  };

  const handleCustomInput = (e) => {
    if (onChange) {
      onChange({ ...value, name: e.target.value });
    }
  };

  return (
    <div className="w-100">
      {/* Dropdown */}
      <select
        name={isOtherSelected ? undefined : name}
        value={
          isOtherSelected
            ? 'other'
            : value && value.id
              ? value.id
              : ''
        }
        onChange={handleSelectChange}
        required={required && !isOtherSelected}
        className="form-control form-control-sm"
      >
        <option value="">{placeholder}</option>
        {options.map((opt) => (
          <option key={opt.id} value={opt.id}>
            {opt.name}
          </option>
        ))}
        <option disabled>──────────</option>
        <option value="other">{otherLabel}</option>
      </select>

      {/* Textbox for "Other" */}
      {isOtherSelected && (
        <input
          type="text"
          name={name}
          value={value && value.name ? value.name : ''}
          onChange={handleCustomInput}
          required={required}
          placeholder={'Enter custom ' + (otherTextBoxPlaceholder || 'value')}
          className="form-control form-control-sm mt-2"
        />
      )}
      {showError && errorMessage && (
        <div className="invalid-feedback d-block">
          {errorMessage}
        </div>
      )}
    </div>
  );
};

export default CustomDropdownWithOther;